<template>
  <div id="auto-save-confirm">
    <ipub-model title=""
                width="480px"
                :visable="isVisable"
                style="text-align:center"
                @confirm="confirm"
                @cancel="cancel">
      <div style="text-align:center">
        <div class="mar-b-20">
          <ipub-icon type="iconsaveprogress"
                     class="ipub-p1 "
                     style="font-size:56px" />
        </div>

        <div class="ipub-h2">Save Changes</div>
        <div class="ipub-p1">Are you sure you want to leave this page without saving?</div>
      </div>

    </ipub-model>
  </div>
</template>
<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: String,
      default: '',
    },
    preEdit: {
      type: String,
      default: '',
    },
  },
  methods: {
    async confirm () {
      this.$emit('confirm')
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}


</script>